import {
  get,
  has,
  invert,
  isString,
  pick,
  random,
  isUndefined,
  fromPairs,
  // isEmpty,
} from 'lodash-es'
// import { constant } from 'change-case'

import APP_CONFIG_CONSTANTS from '@/js/helper/app-config-constants'
// import BIKE_ATTRIBUTES from '@/js/helper/bike-attributes.js'
import FILTER_CONSTANTS from '@/js/helper/filter-constants.js'
import { enrichCatalogTree } from '@/js/helper/catalog-element-helper.js'
import { generateCodeToIdAttributeMap } from '@/js/helper/product-attributes-helper'
import {
  COMPANY_CODE_TO_BRAND,
  CLIENT_TO_COMPANY_CODE,
  BRAND_TO_BRAND_LONG,
} from '@/js/helper/dp-usermanagement-constants'

import GETTER_TYPES from './getter-types'
import CONSTANTS from './constants'
// import { filter } from '@/js/helper/settings-filter.js'

export default {
  [GETTER_TYPES.APP_CONSENT_NECESSARY]: state => {
    return get(state, CONSTANTS.APP_CONSENT, 'necessary', false)
  },
  [GETTER_TYPES.PAY_NOW_TICKET_URL]: state => {
    return get(
      state,
      [CONSTANTS.APP_CONFIG, CONSTANTS.LINKS, CONSTANTS.PAY_NOW_TICKET_URL],
      `/api/bucommonapi?code=pay-now-ticket`,
    )
  },
  [GETTER_TYPES.COMPANY_SEPA_MANDATES]: (state, getters) => {
    return get(getters[GETTER_TYPES.USER], CONSTANTS.DEBIT_CHARGE) || {}
  },
  [GETTER_TYPES.USER_CAN_ISSUE_SEPA_MANDATES]: (state, getters) => {
    return get(getters[GETTER_TYPES.USER], CONSTANTS.CAN_ISSUE_SEPA_MANDATES) || false
  },
  [GETTER_TYPES.EVENT_COUNT]: (state, getters) => {
    return get(getters[GETTER_TYPES.USER], CONSTANTS.EVENT_COUNT) || false
  },
  [GETTER_TYPES.CUSTOMER_EMAIL]: (state, getters) => {
    return get(getters[GETTER_TYPES.USER], CONSTANTS.EMAIL) || {}
  },
  [GETTER_TYPES.APP_CONFIG]: state => {
    return get(state, CONSTANTS.APP_CONFIG)
  },
  [GETTER_TYPES.SHOPMODUS]: state => {
    return get(state, [CONSTANTS.APP_CONFIG, CONSTANTS.SHOPMODE])
  },
  [GETTER_TYPES.LOGOUT_URL]: (state, getters) => {
    return get(
      state,
      [CONSTANTS.APP_CONFIG, CONSTANTS.LOGOUT_URL],
      `/${getters[GETTER_TYPES.LOCALE]}/?dp=${random(9999)}&logintype=logout`,
    )
  },
  [GETTER_TYPES.MESSAGE_STATUS_URL]: state => {
    return get(
      state,
      [CONSTANTS.APP_CONFIG, CONSTANTS.LINKS, CONSTANTS.MESSAGE_STATUS_URL],
      `/api/bucommonapi?code=message-status`,
    )
  },
  [GETTER_TYPES.MESSAGE_LIST_URL]: state => {
    return get(
      state,
      [CONSTANTS.APP_CONFIG, CONSTANTS.LINKS, CONSTANTS.MESSAGE_LIST_URL],
      `/api/bucommonapi?code=message-list`,
    )
  },
  [GETTER_TYPES.MESSAGE_UPDATE_URL]: state => {
    return get(
      state,
      [CONSTANTS.APP_CONFIG, CONSTANTS.LINKS, CONSTANTS.MESSAGE_UPDATE_URL],
      `/api/bucommonapi?code=message-update`,
    )
  },
  [GETTER_TYPES.MESSAGE_ATTACHMENT_URL]: state => {
    return get(
      state,
      [CONSTANTS.APP_CONFIG, CONSTANTS.LINKS, CONSTANTS.MESSAGE_ATTACHMENT_URL],
      `/api/bucommonapi?code=message-update-attachments`,
    )
  },
  [GETTER_TYPES.BU_NEWS_BASE_URL]: (state, getters) => {
    return `${getters[GETTER_TYPES.BASE_URL]}/api/${getters[GETTER_TYPES.LOCALE]}/bunews`
  },
  [GETTER_TYPES.SNIP_URL]: state => {
    return get(
      state,
      [CONSTANTS.APP_CONFIG, CONSTANTS.LINKS, CONSTANTS.SNIP_URL],
      `/api/bucommonapi?code=snip`,
    )
  },
  [GETTER_TYPES.RETURN_API_URL]: state => {
    return get(
      state,
      [CONSTANTS.APP_CONFIG, CONSTANTS.LINKS, CONSTANTS.RETURN_API_URL],
      '/api/bureturnapi',
    )
  },
  [GETTER_TYPES.TESTIVAL_API_URL]: state => {
    return get(
      state,
      [CONSTANTS.APP_CONFIG, CONSTANTS.LINKS, CONSTANTS.TESTIVAL_API_URL],
      '/api/butestivalapi',
    )
  },
  [GETTER_TYPES.SHOPMODE_LOGOUT_URL]: (state, getters) => {
    return `/${getters[GETTER_TYPES.LOCALE]}/`
  },
  [GETTER_TYPES.BASE_URL]: state => {
    const baseUrl = get(state, APP_CONFIG_CONSTANTS.PATHS.BASE_URL, '')

    return baseUrl
  },
  [GETTER_TYPES.LOCALE_BASE_URL]: (state, getters) => {
    const locale = getters[GETTER_TYPES.LOCALE]
    const baseUrl = get(state, APP_CONFIG_CONSTANTS.PATHS.BASE_URL, '')

    return baseUrl ? `${baseUrl}${locale}` : `/${locale}`
  },
  [GETTER_TYPES.TERMS_URL]: state => {
    return get(state, APP_CONFIG_CONSTANTS.PATHS.TERMS)
  },
  [GETTER_TYPES.DASHBOARD_URL]: (state, getters) => {
    const localeBaseUrl = getters[GETTER_TYPES.LOCALE_BASE_URL]

    return `${localeBaseUrl}/dashboard`
  },
  [GETTER_TYPES.BLOCKINGREASON_URL]: state => {
    return get(
      state,
      [CONSTANTS.APP_CONFIG, CONSTANTS.LINKS, CONSTANTS.BLOCKINGREASON_URL],
      '/api/bucommonapi?code=dpgateway&service=blockingreason',
    )
  },
  [GETTER_TYPES.PAYMENT_TERMS_URL]: state => {
    const muleapiserviceUrl = get(state, [
      CONSTANTS.APP_CONFIG,
      CONSTANTS.LINKS,
      CONSTANTS.MULEAPISERVICE_URL,
    ])
    const paymentTermsUrl = muleapiserviceUrl + '/api/payment_term_texts'

    return paymentTermsUrl
  },
  [GETTER_TYPES.SDGP_API_URL]: state => {
    return get(
      state,
      [CONSTANTS.APP_CONFIG, CONSTANTS.LINKS, CONSTANTS.SDGP_API_URL],
      '/api/bucommonapi?code=dpgateway&service=sgdpoverview',
    )
  },
  [GETTER_TYPES.USERMANAGEMENT_URL]: state => {
    return get(state, [CONSTANTS.APP_CONFIG, CONSTANTS.LINKS, CONSTANTS.USERMANAGEMENT_URL])
  },
  [GETTER_TYPES.MULEAPISERVICE_URL]: state => {
    return get(state, [CONSTANTS.APP_CONFIG, CONSTANTS.LINKS, CONSTANTS.MULEAPISERVICE_URL])
  },
  [GETTER_TYPES.RMA_OVERVIEW_PAGE_URL]: state => {
    return get(state, [CONSTANTS.APP_CONFIG, CONSTANTS.LINKS, CONSTANTS.RMA_OVERVIEW_PAGE_URL])
  },
  [GETTER_TYPES.CONNECTED_BIKE_MANUAL_URL]: state => {
    return get(state, [CONSTANTS.APP_CONFIG, CONSTANTS.LINKS, CONSTANTS.CONNECTED_BIKE_MANUAL_URL])
  },
  [GETTER_TYPES.ADMIN_URL]: state => {
    return get(state, [CONSTANTS.APP_CONFIG, CONSTANTS.LINKS, CONSTANTS.ADMIN_URL])
  },
  [GETTER_TYPES.ENVIRONMENT]: state => {
    return get(state, [CONSTANTS.APP_CONFIG, CONSTANTS.ENVIRONMENT])
  },
  [GETTER_TYPES.ENVIRONMENT_TYPO3]: state => {
    return get(state, [CONSTANTS.APP_CONFIG, CONSTANTS.ENVIRONMENT_TYPO3])
  },
  [GETTER_TYPES.LOCALE]: state => {
    return get(state, [CONSTANTS.TWO_LETTER_LOCALE], 'en')
  },
  [GETTER_TYPES.LANGUAGES]: state => {
    return get(state, APP_CONFIG_CONSTANTS.PATHS.LANGUAGES, [])
  },
  [GETTER_TYPES.CATALOG]: state => {
    return get(state, APP_CONFIG_CONSTANTS.PATHS.CATALOG, {})
  },
  // [GETTER_TYPES.CATALOG_TREE]: (state, getters) => {
  //   return buildCatalogTree(getters[GETTER_TYPES.CATALOG])
  // },
  // [GETTER_TYPES.CATALOG_LIST]: (state, getters) => {
  //   return buildCatalogList(getters[GETTER_TYPES.CATALOG_TREE])
  // },
  [GETTER_TYPES.OVERLAY_VISIBILITY]: state => {
    return get(state, CONSTANTS.OVERLAY_IS_VISIBLE)
  },
  [GETTER_TYPES.BASKET_VISIBILITY]: state => {
    return get(state, CONSTANTS.BASKET_IS_VISIBLE)
  },
  [GETTER_TYPES.NAVIGATION_DRAWER_VISIBILITY]: state => {
    return get(state, CONSTANTS.DRAWER_IS_VISIBLE)
  },
  [GETTER_TYPES.PORTAL_TARGETS]: state => {
    return get(state, CONSTANTS.PORTAL_TARGETS)
  },
  [GETTER_TYPES.ENGINE_COMPLAINT_FORM_URL]: state => {
    return get(state, [CONSTANTS.APP_CONFIG, CONSTANTS.LINKS, CONSTANTS.ENGINE_COMPLAINT_FORM_URL])
  },
  [GETTER_TYPES.ENGINE_COMPLAINT_FORM_TITLE]: state => {
    return get(state, [
      CONSTANTS.APP_CONFIG,
      CONSTANTS.LINKS,
      CONSTANTS.ENGINE_COMPLAINT_FORM_TITLE,
    ])
  },
  [GETTER_TYPES.ENGINE_COMPLAINT_WORKTIME_FORM_URL]: state => {
    return get(state, [
      CONSTANTS.APP_CONFIG,
      CONSTANTS.LINKS,
      CONSTANTS.ENGINE_COMPLAINT_WORKTIME_FORM_URL,
    ])
  },
  [GETTER_TYPES.BATTERY_CHARGER_COMPLAINT_FORM_URL]: state => {
    return get(state, [
      CONSTANTS.APP_CONFIG,
      CONSTANTS.LINKS,
      CONSTANTS.BATTERY_CHARGER_COMPLAINT_FORM_URL,
    ])
  },
  [GETTER_TYPES.SERVICE_WARRANTY_PAGE_URL]: state => {
    return get(state, [CONSTANTS.APP_CONFIG, CONSTANTS.LINKS, CONSTANTS.SERVICE_WARRANTY_PAGE_URL])
  },
  [GETTER_TYPES.BACKORDER_PAGE_URL]: state => {
    return get(state, [CONSTANTS.APP_CONFIG, CONSTANTS.LINKS, CONSTANTS.BACKORDER_PAGE_URL])
  },
  // [GETTER_TYPES.SEARCH_DIALOG_VISIBILITY]: state => {
  //   return get(state, CONSTANTS.SEARCH_DIALOG_IS_VISIBLE)
  // },
  // [GETTER_TYPES.SEARCH_QUERY]: state => {
  //   return get(state, [CONSTANTS.SEARCH_PARAMS, FILTER_CONSTANTS.TYPE.SEARCH_TEXT])
  //   // return get(state, CONSTANTS.SEARCH_QUERY)
  // },
  // [GETTER_TYPES.SEARCH_PAGE]: (state, getters) => {
  //   return get(state, [CONSTANTS.SEARCH_PARAMS, FILTER_CONSTANTS.TYPE.SEARCH_PAGE])
  //   // return get(state, CONSTANTS.SEARCH_PAGE)
  // },
  // [GETTER_TYPES.SEARCH_LIMIT]: (state, getters) => {
  //   return get(state, [CONSTANTS.SEARCH_PARAMS, FILTER_CONSTANTS.TYPE.SEARCH_LIMIT])
  // },
  // [GETTER_TYPES.SEARCH_URL]: state => {
  //   return get(state, CONSTANTS.SEARCH_URL)
  // },
  // [GETTER_TYPES.SEARCH_QUERY_MIN_LENGTH]: state => {
  //   return get(state, CONSTANTS.SEARCH_QUERY_MIN_LENGTH)
  // },
  // [GETTER_TYPES.SEARCH_PARAMS]: state => {
  //   return get(state, CONSTANTS.SEARCH_PARAMS)
  // },
  // [GETTER_TYPES.SEARCH_PARAMS_BY_TYPE]: state => type => {
  //   console.log(`SEARCH_PARAMS_BY_TYPE:${type}`)
  //   return get(state, [CONSTANTS.SEARCH_PARAMS, type])
  // },
  [GETTER_TYPES.SEARCH_IMMEDIATE]: state => {
    return get(state, CONSTANTS.SEARCH_IMMEDIATE)
  },
  // [GETTER_TYPES.SEARCH_IS_OVERVIEW]: state => {
  //   return get(state, CONSTANTS.SEARCH_IS_OVERVIEW)
  // },

  [GETTER_TYPES.PRODUCT_VIEW]: state => {
    return get(state, CONSTANTS.PRODUCT_VIEW)
  },
  [GETTER_TYPES.IS_PRODUCT_LIST_VIEW]: state => {
    return get(state, CONSTANTS.PRODUCT_VIEW) === CONSTANTS.PRODUCT_VIEW_TYPE.LIST
  },
  [GETTER_TYPES.IS_PRODUCT_GRID_VIEW]: state => {
    return get(state, CONSTANTS.PRODUCT_VIEW) === CONSTANTS.PRODUCT_VIEW_TYPE.GRID
  },
  [GETTER_TYPES.GET_DIMENSIONS]: state => {
    return get(state, CONSTANTS.DIMENSIONS)
  },
  [GETTER_TYPES.GET_WIDTH]: state => {
    return get(state, [CONSTANTS.DIMENSIONS, CONSTANTS.WIDTH])
  },
  [GETTER_TYPES.IS_XL_WIDTH]: state => {
    const currentWidth = get(state, [CONSTANTS.DIMENSIONS, CONSTANTS.WIDTH], 0)
    return currentWidth > 1264
  },
  [GETTER_TYPES.IS_LG_WIDTH]: state => {
    const currentWidth = get(state, [CONSTANTS.DIMENSIONS, CONSTANTS.WIDTH], 0)
    return currentWidth < 1264
  },
  [GETTER_TYPES.IS_SM_WIDTH]: state => {
    const currentWidth = get(state, [CONSTANTS.DIMENSIONS, CONSTANTS.WIDTH], 0)
    return currentWidth < 960
  },
  [GETTER_TYPES.IS_XS_WIDTH]: state => {
    const currentWidth = get(state, [CONSTANTS.DIMENSIONS, CONSTANTS.WIDTH], 0)
    return currentWidth < 600
  },
  [GETTER_TYPES.GET_HEIGHT]: state => {
    return get(state, [CONSTANTS.DIMENSIONS, CONSTANTS.HEIGHT])
  },
  [GETTER_TYPES.USER]: (state, getters) => {
    return get(getters[GETTER_TYPES.APP_CONFIG], CONSTANTS.USER, {})
  },
  [GETTER_TYPES.CUSTOMER_NUMBER]: (state, getters) => {
    return get(getters[GETTER_TYPES.USER], CONSTANTS.CUSTOMER_NUMBER) || undefined
  },
  [GETTER_TYPES.USERNAME]: (state, getters) => {
    return get(getters[GETTER_TYPES.USER], CONSTANTS.USERNAME) || undefined
  },
  [GETTER_TYPES.SUBUSER]: (state, getters) => {
    const subUser = get(getters[GETTER_TYPES.USER], CONSTANTS.SUBUSER)
    return subUser || undefined
  },
  [GETTER_TYPES.IS_SUBUSER]: (state, getters) => {
    return !!getters[GETTER_TYPES.SUBUSER]
  },
  [GETTER_TYPES.IS_GUEST_SUBUSER]: (state, getters) => {
    return getters[GETTER_TYPES.SUBUSER] === CONSTANTS.SUBUSER_TYPE.GUEST
  },
  [GETTER_TYPES.SUPPORT_USER]: (state, getters) => {
    return get(getters[GETTER_TYPES.USER], CONSTANTS.SUPPORT_USER, false)
  },
  [GETTER_TYPES.SITE_ATTRIBUTES]: (state, getters) => {
    return get(getters[GETTER_TYPES.USER], CONSTANTS.SITE_ATTRIBUTES, [])
  },
  [GETTER_TYPES.USER_BRANDS]: (state, getters) => {
    return getters[GETTER_TYPES.USER_CLIENTS]
      .reduce((acc, client) => {
        const companyCodeBrands = COMPANY_CODE_TO_BRAND[CLIENT_TO_COMPANY_CODE[client]]
        const brands = companyCodeBrands ? companyCodeBrands.split('_') : []
        return [...acc, ...brands]
      }, [])
      .map(brand => ({ brand, long: BRAND_TO_BRAND_LONG[brand] }))
  },
  [GETTER_TYPES.USER_COMPANIES]: (state, getters) => {
    return get(getters[GETTER_TYPES.USER], CONSTANTS.USER_COMPANIES, [])
  },
  [GETTER_TYPES.USER_CLIENTS]: (state, getters) => {
    return get(getters[GETTER_TYPES.USER], CONSTANTS.USER_CLIENTS, [])
  },
  [GETTER_TYPES.USER_GROUPS]: (state, getters) => {
    return get(getters[GETTER_TYPES.USER], CONSTANTS.USER_GROUPS, {})
  },
  [GETTER_TYPES.HAS_ROLE]: (state, getters) => groupKey => {
    const val = isString(groupKey) ? groupKey : get(groupKey, 'p')
    return isUndefined(val) ? false : has(getters[GETTER_TYPES.USER_GROUPS], val)
  },
  [GETTER_TYPES.ROLEIDS_TO_ROLEKEYS]: (state, getters) => {
    return invert(getters[GETTER_TYPES.USER_GROUPS])
  },
  [GETTER_TYPES.GET_ROLEKEYS]: (state, getters) => groupIds => {
    return (Array.isArray(groupIds) ? groupIds : [groupIds]).reduce((acc, groupId) => {
      acc[groupId] = get(getters[GETTER_TYPES.ROLEIDS_TO_ROLEKEYS], groupId)
      return acc
    }, {})
  },
  [GETTER_TYPES.HAS_SPAREPARTS_GROUP]: (state, getters) => {
    // TODO: SSO usermanagement - Check if this group is correct
    return getters[GETTER_TYPES.HAS_ROLE]('shop.parts.r') //getters[GETTER_TYPES.USER_GROUPS].includes('order_spare_parts')
  },
  [GETTER_TYPES.USER_CURRENCY]: (state, getters) => {
    return get(getters[GETTER_TYPES.USER], CONSTANTS.USER_CURRENCY, 'EUR')
  },
  [GETTER_TYPES.HIDE_SPAREPARTS_FROM_USER_COMPANY]: (state, getters) => {
    return get(getters[GETTER_TYPES.USER], CONSTANTS.USER_COMPANIES, []).some(
      userCompany => userCompany.id === '1065',
    )
  },
  [GETTER_TYPES.APP_CONFIG_LINK_BY_TYPE]: state => type => {
    return get(state, `${APP_CONFIG_CONSTANTS.PATHS.LINKS}.${type}`, '')
  },
  [GETTER_TYPES.SPARE_PARTS_GROUPS]: state => {
    return get(state, APP_CONFIG_CONSTANTS.PATHS.SPARE_PARTS_GROUPS, [])
  },
  [GETTER_TYPES.SPAREPARTS_DETAIL_URL]: (state, getters) => {
    return getters[GETTER_TYPES.APP_CONFIG_LINK_BY_TYPE]('sparePartsDetail')
  },
  [GETTER_TYPES.CLIENT_DATA_URL]: (state, getters) => {
    return getters[GETTER_TYPES.APP_CONFIG_LINK_BY_TYPE]('clientData')
  },
  [GETTER_TYPES.SEARCH_DETAIL_LINK]: (state, getters) => {
    return getters[GETTER_TYPES.APP_CONFIG_LINK_BY_TYPE]('searchDetail')
  },
  [GETTER_TYPES.AVAILABILITY_WATCH_URL]: (state, getters) => {
    return getters[GETTER_TYPES.APP_CONFIG_LINK_BY_TYPE]('availabilityWatchUrl')
  },
  // [GETTER_TYPES.FILTER]: (state, getters) => get(getters[GETTER_TYPES.APP_CONFIG], 'filter', {}),
  [GETTER_TYPES.FILTER_CONFIG_DATA]: (state, getters) =>
    get(getters[GETTER_TYPES.APP_CONFIG], 'filter', {}),
  [GETTER_TYPES.ALL_FILTER]: state => get(state, CONSTANTS.FILTERS, {}),
  [GETTER_TYPES.FILTER]: (state, getters) =>
    get(state, [CONSTANTS.FILTERS, getters[GETTER_TYPES.SCOPE], 'attributes'], {}),
  [GETTER_TYPES.FILTER_CATALOG_TREE]:
    (state, getters) =>
    (key = 'Category') =>
      enrichCatalogTree(
        get(
          state,
          [
            CONSTANTS.FILTERS,
            getters[GETTER_TYPES.SCOPE],
            key === 'PimCategory' ? 'pimCatalogTree' : 'catalogTree',
          ],
          {},
        ),
      ),
  [GETTER_TYPES.FILTER_CATALOG]: (state, getters) =>
    get(state, [CONSTANTS.FILTERS, getters[GETTER_TYPES.SCOPE], 'catalogCounts'], {}),
  [GETTER_TYPES.FILTER_SEARCH_TYPE_REVERSE]: (state, getters) =>
    Object.values(getters[GETTER_TYPES.FILTER]).reduce(
      (result, filter) => ({
        ...result,
        ...filter
          .filter(filter =>
            [
              ...FILTER_CONSTANTS.GROUPS[FILTER_CONSTANTS.TYPE.PRODUCT_VARIANTS],
              FILTER_CONSTANTS.TYPE.ARTICLE_TYPE,
            ].includes(filter.type),
          )
          .reduce(
            (acc, item) => ({
              ...acc,
              [item.id]: pick(item, ['type', 'code']),
            }),
            {},
          ),
      }),
      {},
    ),
  [GETTER_TYPES.SCOPE]: state => get(state, CONSTANTS.SCOPE, FILTER_CONSTANTS.SCOPE.ALL),
  [GETTER_TYPES.AVAILABLE_SCOPES]: (state, getters) => {
    return Object.entries(FILTER_CONSTANTS.SCOPE_TO_ARTICLETYPE)
      .filter(([k, v]) => v.every(t => getters[GETTER_TYPES.SCOPE_HAS_ACTIVE_FILTERS][k]))
      .map(([k]) => k)
    // const availableArticleTypes = get(
    //   state,
    //   [
    //     CONSTANTS.FILTERS,
    //     FILTER_CONSTANTS.SCOPE.ALL,
    //     'attributes',
    //     BIKE_ATTRIBUTES.TYPE.ARTICLE_TYPE,
    //   ],
    //   [],
    // )
    //   .filter(i => i.count)
    //   .map(i => i.code)

    // return Object.entries(FILTER_CONSTANTS.SCOPE_TO_ARTICLETYPE)
    //   .filter(([, v]) => v.every(t => availableArticleTypes.includes(t)))
    //   .map(([k]) => k)
  },
  [GETTER_TYPES.FILTER_TYPES]: (state, getters) => Object.keys(getters[GETTER_TYPES.FILTER]),
  [GETTER_TYPES.FILTER_TYPES_GROUPED]: (state, getters) => {
    return [
      ...getters[GETTER_TYPES.FILTER_TYPES].filter(k => !FILTER_CONSTANTS.GROUPED.includes(k)), // Remove Grouped Filters
      ...Object.entries(FILTER_CONSTANTS.GROUPS) // Add Group keys if all Filters for the group are included and NEEDS_ALL_ATTRIBUTES is true
        .filter(
          ([k, v]) =>
            !get(FILTER_CONSTANTS.GROUP_CONFIG, [k, 'NEEDS_ALL_ATTRIBUTES'], false) ||
            v.every(i => getters[GETTER_TYPES.FILTER_TYPES].includes(i)),
        )
        .map(([k]) => k),
    ]
  },
  [GETTER_TYPES.FILTER_BY_TYPE]: (state, getters) => type => {
    if (!getters[GETTER_TYPES.FILTER_TYPES].includes(type)) {
      return undefined
    }
    return getters[GETTER_TYPES.FILTER][type]
  },
  [GETTER_TYPES.SCOPE_HAS_ACTIVE_FILTERS]: (state, getters) => {
    return fromPairs(
      Object.entries(get(state, CONSTANTS.FILTERS, {})).map(([scope, filter]) => [
        scope,
        filter.hasAllDefaultFilters,
      ]),
    )
  },
  // [GETTER_TYPES.ACTIVE_FILTERS_SETTINGS_BY_SCOPE]: () => {
  //   return fromPairs(
  //     Object.entries(get(filter, ['config', 'scope'], {})).map(([scope, scopeConfig]) => {
  //       return [
  //         scope,
  //         Object.entries(get(scopeConfig, 'items', {})).reduce((acc, [attribute, codeConfigs]) => {
  //           const activeCodes = Object.entries(codeConfigs).filter(([code, codeConfig]) => {
  //             return get(codeConfig, 'active') === '1'
  //           })
  //           if (activeCodes.length) {
  //             acc[attribute] = activeCodes.map(([code]) => code)
  //           }
  //           return acc
  //         }, {}),
  //       ]
  //     }),
  //   )
  // },
  [GETTER_TYPES.ALL_ATTRIBUTE_CODE_TO_ID_MAP]: state => {
    return generateCodeToIdAttributeMap(
      get(state, [CONSTANTS.FILTERS, FILTER_CONSTANTS.SCOPE.ALL, 'attributes'], {}),
    )
  },

  [GETTER_TYPES.NOTIFICATION_MESSAGE]: state => {
    return get(state, [CONSTANTS.NOTIFICATION_MESSAGE])
  },
  [GETTER_TYPES.NOTIFICATION_MESSAGE_OPEN]: state => {
    return get(state, [CONSTANTS.NOTIFICATION_MESSAGE_OPEN])
  },
  [GETTER_TYPES.NOTIFICATION_MESSAGE_TYPE]: state => {
    return get(state, [CONSTANTS.NOTIFICATION_MESSAGE_TYPE])
  },
  [GETTER_TYPES.LAUNCH_PORTAL]: state => {
    return get(state, [CONSTANTS.LAUNCH_PORTAL])
  },

  [GETTER_TYPES.NEWS_UNREAD]: state => {
    return get(state, CONSTANTS.NEWS_UNREAD) || 0
  },

  // MESSAGING
  [GETTER_TYPES.MESSAGING_DOMAIN]: state => {
    return get(state, APP_CONFIG_CONSTANTS.PATHS.MESSAGING_DOMAIN)
  },
  [GETTER_TYPES.MESSAGING_WS_PORT]: state => {
    return get(state, APP_CONFIG_CONSTANTS.PATHS.MESSAGING_WS_PORT)
  },
  // [GETTER_TYPES.MESSAGING_TOKEN]: state => {
  //   return get(state, APP_CONFIG_CONSTANTS.PATHS.MESSAGING_TOKEN)
  // },
  [GETTER_TYPES.ZENLOOP_SURVEYS]: (state, getters) => {
    return get(state, `${APP_CONFIG_CONSTANTS.PATHS.ZENLOOP}.${getters[GETTER_TYPES.LOCALE]}`, {})
  },
  [GETTER_TYPES.SELECTED_BRAND]: state => {
    return get(state, CONSTANTS.SELECTED_BRAND)
  },
  [GETTER_TYPES.CURRENT_LANG_CODE]: state => {
    return get(state, APP_CONFIG_CONSTANTS.PATHS.CURRENT_LANG_CODE)
  },
  [GETTER_TYPES.HUBSPOT_MIDDLEWARE_FORM_API]: state => {
    return get(state, APP_CONFIG_CONSTANTS.PATHS.HUBSPOT_MIDDLEWARE_FORM_API)
  },
  [GETTER_TYPES.HUBSPOT_MIDDLEWARE_VISITOR_IDENTIFICATION_API]: state => {
    return get(state, APP_CONFIG_CONSTANTS.PATHS.HUBSPOT_MIDDLEWARE_VISITOR_IDENTIFICATION_API)
  },
  [GETTER_TYPES.CUSTOMER_COUNTRYID]: state => {
    return get(state, APP_CONFIG_CONSTANTS.CUSTOMER_COUNTRYID)
  },
  [GETTER_TYPES.CUSTOMER_LANGUAGEID]: state => {
    return get(state, APP_CONFIG_CONSTANTS.CUSTOMER_LANGUAGEID)
  },
  [GETTER_TYPES.CUSTOMER_FIRSTNAME]: state => {
    return get(state, APP_CONFIG_CONSTANTS.CUSTOMER_FIRSTNAME)
  },
  [GETTER_TYPES.CUSTOMER_LASTNAME]: state => {
    return get(state, APP_CONFIG_CONSTANTS.CUSTOMER_LASTNAME)
  },
  [GETTER_TYPES.CUSTOMER_TELEPHONE]: state => {
    return get(state, APP_CONFIG_CONSTANTS.CUSTOMER_TELEPHONE)
  },
}
